import React from "react";
import Moviedemo from "./Moviedemo";

const Home = () => {
  return (
    <div>
      <Moviedemo />
    </div>
  );
};

export default Home;
